import { render, staticRenderFns } from "./MasterMenuApiSubMenu.vue?vue&type=template&id=21796392&scoped=true&"
import script from "./MasterMenuApiSubMenu.vue?vue&type=script&lang=js&"
export * from "./MasterMenuApiSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./MasterMenuApiSubMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MasterMenuApiSubMenu.vue?vue&type=style&index=1&id=21796392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21796392",
  null
  
)

export default component.exports